import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'odq-section-separator',
    templateUrl: './section-separator.component.html',
    styleUrls: ['./section-separator.component.scss'],
    standalone: false
})
export class SectionSeparatorComponent implements OnInit {

  // @Input() class: string = '';
  // @HostBinding('class')
  // get hostClasses(): string {
	// 	return [
	// 		this.class, // include our new one
	// 	].join(' ');
	// }
  constructor() { }

  ngOnInit() {
  }

}
